import React, { useState } from 'react';
import { useSelector } from 'store';
import { AxiosResponse } from 'axios';
import { GetRecentPostAPI } from 'api/community';
import { makeAuthorizationConfig } from 'utils';
import { ERROR_500 } from 'constants/message';
import { useDispatch } from 'react-redux';
import { communityActions } from 'store/community';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import ViewNewFeed from './components/common/ViewNewFeed';
import TopNotice from './components/common/TopNotice';
import NoticeCard from './components/feed/NoticeCard';
import EventCard from './components/feed/EventCard';
import FeedCard from './components/feed/FeedCard';
import CommunitySideMenu from './components/common/CommunitySideMenu';
import { Spinner } from '../common/Spinner';

const NewPostService: React.FC = () => {
  const access = useSelector(state => state.accounts.access);
  const communityList = useSelector(state => state.community.communityList);
  const feeds = communityList.results;
  const [count, setCount] = useState(10);
  const { has_more } = communityList;

  const dispatch = useDispatch();

  const viewNoFeed = () => (
    <div className="no-feed">
      <p>
        이야기가 아직 없습니다,
        <br />
        멤버들에게 당신의 이야기를 들려주세요~
      </p>
    </div>
  );

  const onLoadMore = async () => {
    const value = count + 10;

    const config = makeAuthorizationConfig(access);
    const response: AxiosResponse = await GetRecentPostAPI(config, value);

    if (response.status >= 400) {
      alert(ERROR_500);
      return;
    }

    dispatch(communityActions.getCommunityList(response.data));
    setCount(value);
  };

  const likeCallback = async () => {
    const config = makeAuthorizationConfig(access);
    const response: AxiosResponse = await GetRecentPostAPI(config, count);
    dispatch(communityActions.getCommunityList(response.data));
  };

  return (
    <CommunityWrapper className="community-wrap">
      <div className="inner">
        <CommunitySideMenu selected="최신글" />
        <div className="comt-cnts" style={{ paddingTop: 48 }}>
          {/* 검색 */}
          <TopNotice />
          <div className="community-inw">
            <ViewNewFeed />
            <div className="community-detail">
              <InfiniteScroll
                pageStart={0}
                loadMore={onLoadMore}
                hasMore={has_more}
                loader={<Spinner key="spinner" />}
              >
                {feeds.length > 0
                  ? feeds.map((feed, index) => {
                      if (feed.type === 'event')
                        return <EventCard feed={feed} key={index} />;
                      if (feed.type === 'post')
                        return (
                          <FeedCard
                            feed={feed}
                            key={index}
                            callback={likeCallback}
                          />
                        );
                      if (feed.type === 'notice')
                        return (
                          <NoticeCard
                            feed={feed}
                            key={index}
                            callback={likeCallback}
                          />
                        );
                    })
                  : viewNoFeed()}
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>
    </CommunityWrapper>
  );
};

const CommunityWrapper = styled.div`
  @media screen and (max-width: 786px) {
    padding-top: 16px;
  }
`;

export default NewPostService;
